import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { DialogService } from 'primeng/dynamicdialog';
import { MessageModule } from 'primeng/message';
import { TabsModule } from 'primeng/tabs';

import { ConfirmAndNotifyDialogComponent } from 'editing-tool/src/app/shared/components/confirm-and-notify-dialog/confirm-and-notify-dialog.component';
import { EditPeriodComponent } from 'editing-tool/src/app/shared/components/edit-period/edit-period.component';
import { HeaderAutocompleteComponent } from 'editing-tool/src/app/shared/components/header-autocomplete/header-autocomplete.component';
import { CreateKeywordsDialogComponent } from 'editing-tool/src/app/shared/components/keyword/create-keywords-dialog/create-keywords-dialog.component';
import { KeywordListComponent } from 'editing-tool/src/app/shared/components/keyword/keyword-list.component';
import { PaperHistoryDialogComponent } from 'editing-tool/src/app/shared/components/paper/history/paper-history-dialog.component';
import { PaperLayoutComponent } from 'editing-tool/src/app/shared/components/paper/paper-layout.component';
import { ReviewReportChecklistItemComponent } from 'editing-tool/src/app/shared/components/paper/review-report/review-report-checklist-item/review-report-checklist-item.component';
import { ReviewReportComponent } from 'editing-tool/src/app/shared/components/paper/review-report/review-report.component';
import { PaperAuthorAffiliationDialogComponent } from 'editing-tool/src/app/shared/components/paper/steps/authors/affiliation-dialog/paper-author-affiliation-dialog.component';
import { PaperAuthorCreateDialogComponent } from 'editing-tool/src/app/shared/components/paper/steps/authors/author-create-dialog/paper-author-create-dialog.component';
import { AuthorEntryComponent } from 'editing-tool/src/app/shared/components/paper/steps/authors/author-entry/author-entry.component';
import { PaperAuthorSearchDialogComponent } from 'editing-tool/src/app/shared/components/paper/steps/authors/author-search-dialog/paper-author-search-dialog.component';
import { PaperAuthorsComponent } from 'editing-tool/src/app/shared/components/paper/steps/authors/paper-authors.component';
import { PaperAuthorsAffiliationRendererComponent } from 'editing-tool/src/app/shared/components/paper/steps/authors/renderers/affiliation/paper-authors-affiliation-renderer.component';
import { PaperAuthorsFirstNameRendererComponent } from 'editing-tool/src/app/shared/components/paper/steps/authors/renderers/first-name/paper-authors-first-name-renderer.component';
import { PaperChecklistComponent } from 'editing-tool/src/app/shared/components/paper/steps/checklist/paper-checklist.component';
import { PaperCopyrightDownloadComponent } from 'editing-tool/src/app/shared/components/paper/steps/copyright/paper-copyright-download/paper-copyright-download.component';
import { PaperCopyrightFormComponent } from 'editing-tool/src/app/shared/components/paper/steps/copyright/paper-copyright-form/paper-copyright-form.component';
import { PaperCopyrightComponent } from 'editing-tool/src/app/shared/components/paper/steps/copyright/paper-copyright.component';
import { PaperDetailsComponent } from 'editing-tool/src/app/shared/components/paper/steps/details/paper-details.component';
import { PaperFileHistoryListDialogComponent } from 'editing-tool/src/app/shared/components/paper/steps/details/paper-file-history-list-dialog/paper-file-history-list-dialog.component';
import { PaperKeywordsComponent } from 'editing-tool/src/app/shared/components/paper/steps/keywords/paper-keywords.component';
import { PaperProjectComponent } from 'editing-tool/src/app/shared/components/paper/steps/project/paper-project/paper-project.component';
import { PaperProjectListComponent } from 'editing-tool/src/app/shared/components/paper/steps/project/paper-project-list.component';
import { PaperReferencesComponent } from 'editing-tool/src/app/shared/components/paper/steps/references/paper-references.component';
import { ReuploadReferencesDialogComponent } from 'editing-tool/src/app/shared/components/paper/steps/references/reupload-references-dialog/reupload-references-dialog.component';
import { StepLayoutComponent } from 'editing-tool/src/app/shared/components/paper/steps/step-layout.component';
import { SupplementMaterialsRendererComponent } from 'editing-tool/src/app/shared/components/paper/steps/supplements/materials-renderer/supplement-materials-renderer.component';
import { PaperSupplementsComponent } from 'editing-tool/src/app/shared/components/paper/steps/supplements/paper-supplements.component';
import { SupplementFileDialogComponent } from 'editing-tool/src/app/shared/components/paper/steps/supplements/supplement-file-dialog/supplement-file-dialog.component';
import { SupplementLinkDialogComponent } from 'editing-tool/src/app/shared/components/paper/steps/supplements/supplement-link-dialog/supplement-link-dialog.component';
import { PaperTemplatesComponent } from 'editing-tool/src/app/shared/components/paper/steps/templates/paper-templates.component';
import { ParticipantHeaderComponent } from 'editing-tool/src/app/shared/components/participant-header/participant-header.component';
import { SearchMemberComponent } from 'editing-tool/src/app/shared/components/search-member/search-member.component';
import { WelcomeBlockComponent } from 'editing-tool/src/app/shared/components/welcome-block/welcome-block.component';
import { NotificationDialogComponent } from 'editing-tool/src/app/shared/notification/notification-dialog/notification-dialog.component';
import { ScDialogService } from 'sc-common';
import { ExternalSharedModule } from 'sc-external/shared/external-shared.module';

@NgModule({
    imports: [
        ExternalSharedModule,
        RouterModule,
        CardModule,
        DividerModule,
        MessageModule,
        AutoCompleteModule,
        TabsModule
    ],
    declarations: [
        PaperLayoutComponent,
        PaperAuthorsComponent,
        PaperChecklistComponent,
        PaperCopyrightComponent,
        PaperCopyrightDownloadComponent,
        PaperCopyrightFormComponent,
        PaperDetailsComponent,
        PaperFileHistoryListDialogComponent,
        PaperKeywordsComponent,
        PaperProjectListComponent,
        PaperReferencesComponent,
        PaperSupplementsComponent,
        PaperTemplatesComponent,
        StepLayoutComponent,
        NotificationDialogComponent,
        AuthorEntryComponent,
        PaperAuthorsAffiliationRendererComponent,
        PaperAuthorsFirstNameRendererComponent,
        PaperAuthorAffiliationDialogComponent,
        PaperAuthorCreateDialogComponent,
        ReuploadReferencesDialogComponent,
        SearchMemberComponent,
        SupplementMaterialsRendererComponent,
        SupplementLinkDialogComponent,
        SupplementFileDialogComponent,
        PaperProjectComponent,
        PaperAuthorSearchDialogComponent,
        EditPeriodComponent,
        ParticipantHeaderComponent,
        WelcomeBlockComponent,
        KeywordListComponent,
        HeaderAutocompleteComponent,
        CreateKeywordsDialogComponent,
        ReviewReportComponent,
        ReviewReportChecklistItemComponent,
        ConfirmAndNotifyDialogComponent,
        PaperHistoryDialogComponent
    ],
    exports: [
        ExternalSharedModule,
        AutoCompleteModule,
        CardModule,
        DividerModule,
        MessageModule,
        TabsModule,
        SearchMemberComponent,
        PaperLayoutComponent,
        PaperAuthorsComponent,
        PaperChecklistComponent,
        PaperCopyrightComponent,
        PaperKeywordsComponent,
        PaperProjectListComponent,
        PaperReferencesComponent,
        PaperSupplementsComponent,
        PaperTemplatesComponent,
        PaperDetailsComponent,
        EditPeriodComponent,
        ParticipantHeaderComponent,
        WelcomeBlockComponent,
        KeywordListComponent,
        StepLayoutComponent,
        ReviewReportComponent,
        ConfirmAndNotifyDialogComponent
    ],
    providers: [
        DialogService,
        ScDialogService,
        { provide: DialogService, useExisting: ScDialogService }
    ]
})
export class SharedModule {
}
